import { css } from "@emotion/css";
import { fontWeight } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { ChannelConfigurationCardWithRawInputs } from "../EphemeralEnvironmentsConfigurationCards";
import ephemeralEnvironmentInfoImage from "../assets/ephemeral-env-channel-info-dark.svg";
import { ConfigWizardHelpLayout } from "./ConfigWizardHelpLayout";
import type { ReviewContentProps } from "./ReviewContent";
import { ReviewContent } from "./ReviewContent";
export function SuccessHelp() {
    return (<ConfigWizardHelpLayout title="Ephemeral Environments Channel">
            <p>New releases created in this channel will automatically provision a new ephemeral environment based on environment name template provided (the example above is using branch name). The release is then deployed to that environment.</p>
            <p>The selected parent environment supplies the deployment targets, accounts, and variables that every ephemeral environment inherits.</p>
        </ConfigWizardHelpLayout>);
}
export const successHelpImage = { src: ephemeralEnvironmentInfoImage, altText: "Graphic of a release and a parent environment passing values to an ephemeral environment" };
interface SuccessContentProps extends ReviewContentProps {
    channelName?: string;
}
export function SuccessContent(props: SuccessContentProps) {
    const styles = {
        successMessage: css({
            fontWeight: fontWeight["500"],
        }),
    };
    if (!props.parentEnvironmentConfig.name) {
        throw new Error("Missing parent environment configuration.");
    }
    if (!props.channelName) {
        throw new Error("Missing channel name.");
    }
    return (<div>
            <ReviewContent {...props}/>
            <h3 className={styles.successMessage}>We've created an ephemeral environment channel for you!</h3>
            <ChannelConfigurationCardWithRawInputs channelName={props.channelName} parentEnvironmentName={props.parentEnvironmentConfig.name} ephemeralEnvironmentNameTemplate={props.nameTemplateConfig} automaticEphemeralEnvironmentDeployments={props.automaticEphemeralEnvironmentDeployments}/>
        </div>);
}
